var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSchedule({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M56.27 22.35v-4.12a6.25 6.25 0 00-6.25-6.26H47m-32.98 0H11a6.26 6.26 0 00-6.26 6.26v32A6.25 6.25 0 0011 56.47h15.08m7.42-44.5h-6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M19.04 29.85a2 2 0 00-2-2H15a2 2 0 00-2 2v2.03a2 2 0 002 2h2.03a2 2 0 002-2v-2.03zm.36 12.87a2 2 0 00-2-2h-2.04a2 2 0 00-2 2v2.03a2 2 0 002 2h2.04a2 2 0 002-2v-2.03zm14.12-13.11h0a1.76 1.76 0 00-1.76-1.76h-2.27a2 2 0 00-2 2v2.03a2 2 0 002 2h.22m-6.64-11.53h33.2m-51.54 0h7.47M22.85 9.28a1.99 1.99 0 00-1.99-1.99s0 0 0 0a1.99 1.99 0 00-1.99 1.99v5.4a1.99 1.99 0 001.99 1.98s0 0 0 0a1.98 1.98 0 001.99-1.99v-5.4zm19.28 0a1.99 1.99 0 00-1.98-1.99s0 0 0 0a1.99 1.99 0 00-1.99 1.99v5.4a1.98 1.98 0 001.99 1.98s0 0 0 0a1.98 1.98 0 001.98-1.99v-5.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M51.69 30.56a18.58 18.58 0 11-.02 37.17 18.58 18.58 0 01.02-37.17zm-3.28 8h7.27v7.27h7.27v7.27h-7.28v7.27H48.4V53.1l-7.27.01v-7.27h7.28v-7.28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSchedule);
export default __webpack_public_path__ + "static/media/add-schedule.dfda093f5ca6b94acb5e97b22a750e10.svg";
export { ForwardRef as ReactComponent };